<div class="plan-payment" *ngIf="!isLoading; else loadingTpl" [class.embedded]="embeddedMode">
  <umkt-breadcrumb *ngIf="!embeddedMode" [items]="breadcrumbItems" [separator]="'>'"></umkt-breadcrumb>
  <h2 class="plan-payment__title">{{ 'pages.planPayment.title' | i18n }}</h2>

  <section class="plan-payment__content" *ngIf="plan as p">
    <div class="plan-payment__body">
      <h3 class="plan-payment__body-title">{{ 'pages.planPayment.subtitle' | i18n }}</h3>
      
      <div class="plan-payment-method">
        <strong>{{ 'pages.planPayment.currentMethod' | i18n }}</strong>
        <span class="payment-info">
          <img 
            [src]="p?.cardFlag | getCreditCardIconSrc" 
            [alt]="p?.cardFlag || 'boleto'" 
            class="card-icon"
          >
          {{ p?.cardFlag | paymentText: p?.lastFourDigits }} 
        </span>
        <div class="border-line"></div>
      </div>

      <div class="plan-cards__content">
        <umkt-plan-payment-card 
          [currentCardToken]="initialCardId" 
          (cardFormVisibilityChange)="onCardFormVisibilityChange($event)" 
          (tokenCardSelected)="onCardSelectionChange($event)">
        </umkt-plan-payment-card>
      </div>

      <div class="plan-payment__actions" *ngIf="!isCardFormVisible">
        <umkt-action-button 
          [label]="'shared.buttons.cancel' | i18n" 
          variant="outline" 
          (clicked)="cancel()">
        </umkt-action-button>

        <umkt-action-button 
          [label]="'shared.buttons.save' | i18n" 
          variant="primary" 
          (clicked)="save()" 
          [disabled]="!isSaveButtonEnabled()">
        </umkt-action-button>
      </div>
    </div>
  </section>
</div>

<ng-template #loadingTpl>
  <umkt-loading [isLoading]="isLoading"></umkt-loading>
</ng-template>